import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1e99cbd7")
const _hoisted_1 = { class: "partner-modal" }
const _hoisted_2 = { class: "partner-hint" }
_popScopeId()

import { computed, reactive, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  /** The organization's current partner status. */
  currentValue: {
    type: Boolean,
    required: true
  }
},
  emits: ["cancel", "validate"],
  setup(__props, { emit }) {

const props = __props




const state = reactive({
  isOpen: computed(() => props.isOpen)
});

const isPartner = ref(props.currentValue);

const hasChanged = computed(() => isPartner.value !== props.currentValue);

watch(() => props.currentValue, (value) => {
  isPartner.value = value;
});

watch(() => props.isOpen, (open) => {
  if (open) {
    isPartner.value = props.currentValue;
  }
});

function onSave() {
  if (hasChanged.value) {
    emit("validate", isPartner.value);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_va_switch = _resolveComponent("va-switch")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createBlock(_component_va_modal, {
    modelValue: _unref(state).isOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(state).isOpen = $event)),
    "hide-default-actions": "",
    title: _ctx.$t('organizations.partnerModal.title')
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_va_button, {
        flat: "",
        outline: "",
        class: "mr-1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("buttons.cancel")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_va_button, {
        class: "ml-1",
        color: "success",
        disabled: !_unref(hasChanged),
        onClick: onSave
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("organizations.partnerModal.save")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_va_switch, {
          modelValue: isPartner.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (isPartner.value = $event)),
          label: _ctx.$t('organizations.isPartner')
        }, null, 8, ["modelValue", "label"]),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("organizations.partnerHint")), 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})